
import { request } from "./request";

// 地图预约-中心列表
export function getCenterList(data) {
    return request({
        url: `/rest/wxqueue/getCenterList`,
        method: "post",
        data:data
    });
}

// 地图预约-大事项分类获取事项
export function getLargeTaskTypeList(data) {
    return request({
        url: `/rest/wxqueue/getLargeTaskTypeList`,
        method: "post",
        data:data
    });
}

// 地图预约-预约接口获取事项
export function getTaskTypeList(data) {
    return request({
        url: `/rest/wxqueue/getTaskTypeList`,
        method: "post",
        data:data
    });
}

// 地图预约-获取预约日期及相关日期可预约时间段
export function getAppointTime(data) {
    return request({
        url: `/rest/wxqueue/private/getAppointTime`,
        method: "post",
        data:data
    });
}

// 地图预约-预约取号
export function getAppointQno(data) {
    return request({
        url: `/rest/wxqueue/private/getAppointQno`,
        method: "post",
        data:data
    });
}

// 地图预约-预约列表
export function getAppointList(data) {
    return request({
        url: `/rest/wxqueue/private/getAppointList`,
        method: "post",
        data:data
    });
}

// 地图预约-删除预约接口
export function deleteAppoint(data) {
    return request({
        url: `/rest/wxqueue/deleteAppoint`,
        method: "post",
        data:data
    });
}

// 地图预约-预约详情
export function getAppointDetail(data) {
    return request({
        url: `/rest/wxqueue/getAppointDetail`,
        method: "post",
        data:data
    });
}

// ========== 网点相关接口 ==========

// 获取全部网点列表
export function getAllSiteList(data) {
    return request({
        url: `/lilo/api/map/site/getAllList`,
        method: "post",
        params: data
    });
}

// 获取附近网点列表
export function getNearbyList(data) {
    return request({
        url: `/lilo/api/map/site/getNearbyList`,
        method: "post",
        params: data
    });
}

// 搜索网点
export function searchSite(data) {
    return request({
        url: `/lilo/api/map/site/search`,
        method: "post",
        params: data
    });
}

// 获取网点详情
export function getSiteDetail(data) {
    return request({
        url: `/lilo/api/map/site/getDetail`,
        method: "post",
        params: data
    });
}

// 按网点类型筛选
export function getListBySiteType(data) {
    return request({
        url: `/lilo/api/map/site/getListBySiteType`,
        method: "post",
        data: data
    });
}

// 按区域筛选
export function getListByAreaCode(data) {
    return request({
        url: `/lilo/api/map/site/getListByAreaCode`,
        method: "post",
        data: data
    });
}

// ========== 事项相关接口 ==========

// 获取事项列表
export function getProjectList(data) {
    return request({
        url: `/lilo/api/project/getList`,
        method: "post",
        params: data
    });
}

// 获取事项表单列表
export function getProjectForms(projectId, data) {
    return request({
        url: `/lilo/api/project/${projectId}/forms`,
        method: "get",
        params: data
    });
}

// 搜索事项（带关键词）
export function searchProject(data) {
    return request({
        url: `/lilo/api/project/getList`,
        method: "post",
        params: data
    });
}

// ========== 区域相关接口 ==========

// 获取区划树
export function getAreaTree(data) {
    return request({
        url: `/lilo/api/area/getTree`,
        method: "post",
        params: data
    });
}

// 获取区划列表
export function getAreaList(data) {
    return request({
        url: `/lilo/api/area/getList`,
        method: "post",
        params: data
    });
}

// 获取默认区划
export function getDefaultArea() {
    return request({
        url: `/lilo/api/area/getDefaultArea`,
        method: "post"
    });
}

// 获取兴趣标签列表
export function getInterestTags() {
    return request({
        url: `/lilo/api/project/getInterestTags`,
        method: "post"
    });
}

// 获取办理方式标签
export function getHandleTags() {
    return request({
        url: `/lilo/api/project/getHandleTags`,
        method: "post"
    });
}

// 获取收藏列表
export function getFavoriteList(data) {
    return request({
        url: `/lilo/api/project/favorite/list`,
        method: "post",
        params: data
    });
}

// 添加事项收藏
export function addFavorite(data) {
    return request({
        url: `/lilo/api/project/favorite/add`,
        method: "post",
        params: data
    });
}

// 取消事项收藏
export function removeFavorite(data) {
    return request({
        url: `/lilo/api/project/favorite/remove`,
        method: "post",
        params: data
    });
}

// 检查是否已收藏
export function checkFavorite(data) {
    return request({
        url: `/lilo/api/project/favorite/check`,
        method: "post",
        params: data
    });
}

// ========== 用户相关接口 ==========

// 用户登录
export function userLogin(data) {
    const { username, password } = data;
    return request({
        url: `/login?username=${username}&password=${password}`,
        method: "post"
    });
}

// 获取部门列表
export function getDeptList(data) {
    return request({
        url: `/lilo/api/dept/getList`,
        method: "post",
        params: data
    });
}

// 获取预约部门列表
export function getSubscribeDeptList(data) {
    return request({
        url: `/lilo/api/subscribe/getSubscribeDeptList`,
        method: "post",
        params: data
    });
}

// 通过部门ID获取预约业务列表
export function getSubscribeQueueListByDeptID(data) {
    return request({
        url: `/lilo/api/subscribe/getSubscribeQueueListByDeptID`,
        method: "post",
        params: data
    });
}

// 通过部门ID获取预约事项列表（事项模式）
export function getListSubscribeProjectByDeptID(data) {
    return request({
        url: `/lilo/api/subscribe/getListSubscribeProjectByDeptID`,
        method: "post",
        params: data
    });
}

// 获取事项办事指南详情
export function getProjectSummary(data) {
    return request({
        url: `/lilo/api/project/getSummary`,
        method: "post",
        params: data
    });
}

// 获取预约日期（业务模式，传queueid）
export function getListSubscribeDate(data) {
    const { areacode, queueid } = data;
    return request({
        url: `/lilo/api/subscribe/getListSubscribeDate?areacode=${areacode || ''}&queueid=${queueid || ''}&projectno=""`,
        method: "post"
    });
}

// 获取预约日期（事项模式，传projectno）
export function getListSubscribeDateByProject(data) {
    const { areacode, projectno } = data;
    return request({
        url: `/lilo/api/subscribe/getListSubscribeDate?areacode=${areacode || ''}&projectno=${projectno || ''}`,
        method: "post"
    });
}

// 获取预约时间（业务模式，传queueid）
export function getListSubscribeTime(data) {
    const { stime, areacode, week, queueid } = data;
    return request({
        url: `/lilo/api/subscribe/getListSubscribeTime?stime=${stime || ''}&areacode=${areacode || ''}&week=${week || ''}&queueid=${queueid || ''}&projectno=""`,
        method: "post"
    });
}

// 获取预约时间（事项模式，传projectno）
export function getListSubscribeTimeByProject(data) {
    const { stime, areacode, week, projectno } = data;
    return request({
        url: `/lilo/api/subscribe/getListSubscribeTime?stime=${stime || ''}&areacode=${areacode || ''}&week=${week || ''}&projectno=${projectno || ''}`,
        method: "post"
    });
}

// 添加预约（业务模式，传queueid）
export function addSubscribe(data) {
    const { orderdate, ordertime, week, prmid, idcard, prmname, mobile, clienttype, queueid, areacode } = data;
    return request({
        url: `/lilo/api/subscribe/addSubscribe?orderdate=${orderdate || ''}&ordertime=${ordertime || ''}&week=${week || ''}&prmid=${prmid || '""'}&idcard=${idcard || ''}&prmname=${prmname || ''}&mobile=${mobile || ''}&clienttype=${clienttype || '1'}&projectno=""&queueid=${queueid || ''}&areacode=${areacode || ''}`,
        method: "post"
    });
}

// 添加预约（事项模式，传projectno）
export function addSubscribeByProject(data) {
    const { orderdate, ordertime, week, prmid, idcard, prmname, mobile, clienttype, projectno, areacode } = data;
    return request({
        url: `/lilo/api/subscribe/addSubscribe?orderdate=${orderdate || ''}&ordertime=${ordertime || ''}&week=${week || ''}&prmid=${prmid || ''}&idcard=${idcard || ''}&prmname=${prmname || ''}&mobile=${mobile || ''}&clienttype=${clienttype || '1'}&projectno=${projectno || ''}&areacode=${areacode || ''}`,
        method: "post"
    });
}

// 根据身份证号获取预约列表
export function getListSubscribeByIDCard(data) {
    return request({
        url: `/lilo/api/subscribe/getListSubscribeByIDCard`,
        method: "post",
        params: data
    });
}

// 取消预约
export function cancelSubscribe(data) {
    const params = new URLSearchParams();
    params.append('subid', data.subid);
    return request({
        url: `/lilo/api/subscribe/cancelSubscribeBySubID`,
        method: "post",
        data: params
    });
}

// ========== 热门搜索相关接口 ==========

// 获取热门事项列表
export function getHotProjectList(data) {
    return request({
        url: `/lilo/api/project/getHotList`,
        method: "post",
        params: data
    });
}

// 增加事项点击量
export function addProjectClick(data) {
    return request({
        url: `/lilo/api/project/addClick`,
        method: "post",
        params: data
    });
}

// 获取热门站点列表
export function getHotSiteList(data) {
    return request({
        url: `/lilo/api/map/site/getHotList`,
        method: "post",
        params: data
    });
}

// 增加站点点击量
export function addSiteClick(data) {
    return request({
        url: `/lilo/api/map/site/addClick`,
        method: "post",
        params: data
    });
}


// ========== 取号服务接口 ==========

// 通过takid获取取号信息
export function getNumberInfoByTakID(data) {
    return request({
        url: `/lilo/api/takingNumber/getNumberInfoByTakID`,
        method: "post",
        params: data
    });
}

// 通过areacode获取部门列表（取号）
export function getTakingDeptListByAreaCode(data) {
    return request({
        url: `/lilo/api/takingNumber/getListAllDeptByAreaCode`,
        method: "post",
        params: data
    });
}

// 通过deptid获取业务列表（取号）
export function getTakingQueueListByDeptID(data) {
    return request({
        url: `/lilo/api/takingNumber/getListAllQueueByDeptID`,
        method: "post",
        params: data
    });
}

// 通过areacode获取业务分类
export function getQueueClassByAreaCode(data) {
    return request({
        url: `/lilo/api/takingNumber/getListQueueClassByAreaCode`,
        method: "post",
        params: data
    });
}

// 通过classid获取业务
export function getQueueByClassID(data) {
    return request({
        url: `/lilo/api/takingNumber/getListAllQueueByClassID`,
        method: "post",
        params: data
    });
}

// 通过身份证获取当天取号记录
export function getTakingListByIDCard(data) {
    return request({
        url: `/lilo/api/takingNumber/getListNumberInfoByIDCard`,
        method: "post",
        params: data
    });
}

// 添加取号
export function addTakingNumber(data) {
    const { clienttype, queueid, idcard, prmid, prmname, mobile, areacode, projectno } = data;
    const params = new URLSearchParams();
    params.append('clienttype', clienttype || '4');
    if (queueid) params.append('queueid', queueid);
    if (projectno) params.append('projectno', projectno);
    if (prmid) params.append('prmid', prmid);
    if (idcard) params.append('idcard', idcard);
    if (prmname) params.append('prmname', prmname);
    if (mobile) params.append('mobile', mobile);
    if (areacode) params.append('areacode', areacode);
    return request({
        url: `/lilo/api/takingNumber/getQueueNumByOnline?${params.toString()}`,
        method: "post"
    });
}

// 取消取号
export function cancelTakingNumber(data) {
    return request({
        url: `/lilo/api/takingNumber/cancelNumberByTakID`,
        method: "post",
        params: data
    });
}

// 获取当前业务办理窗口
export function getDeptWindowByQueueID(data) {
    return request({
        url: `/lilo/api/takingNumber/getListDeptWindowByQueueID`,
        method: "post",
        params: data
    });
}

// 获取当前业务平均办理时间
export function getQueueAvgDealTime(data) {
    return request({
        url: `/lilo/api/takingNumber/getQueueAvgDealTime`,
        method: "post",
        params: data
    });
}

// 获取当前业务等待人数
export function getWaitNumByQueueID(data) {
    return request({
        url: `/lilo/api/takingNumber/getWaitNumByQueueID`,
        method: "post",
        params: data
    });
}

// ========== 消息中心接口 ==========

// 查询消息记录（旧接口，保留兼容）
export function queryMessageRecords(data) {
    return request({
        url: `/msg/queryRecords`,
        method: "post",
        data: data
    });
}

// 根据手机号查询消息
export function queryMessageByMobile(data) {
    return request({
        url: `/msg/queryRecords`,
        method: "post",
        data: data
    });
}

// 标记消息为已读
export function markMessageRead(msgId) {
    return request({
        url: `/msg/markRead`,
        method: "post",
        data: { msgId }
    });
}

// 批量标记消息为已读
export function batchMarkMessageRead(msgIds) {
    return request({
        url: `/msg/batchMarkRead`,
        method: "post",
        data: { msgIds }
    });
}

// 标记所有消息为已读
export function markAllMessageRead(mobile) {
    return request({
        url: `/msg/markAllRead`,
        method: "post",
        params: { mobile }
    });
}
